import { INotificationSseEvent } from '../../interfaces/notifications.interface';

export namespace NotificationActions {
    export class GetNotifications {
      static readonly type = '[Notification] Get Notifications';
    }

    export class StartPolling {
      static readonly type = '[Notification] Start Polling';
      constructor(public intervalMs?: number) {}
    }

    export class StopPolling {
      static readonly type = '[Notification] Stop Polling';
    }

    export class RefreshNotifications {
      static readonly type = '[Notification] Refresh Notifications';
    }

    export class MarkAsRead {
      static readonly type = '[Notification] Mark As Read';
      constructor(public notificationIds: number[]) {}
    }

    export class MarkAllAsRead {
      static readonly type = '[Notification] Mark All As Read';
    }

    export class AddFromSse {
      static readonly type = '[Notification] Add From SSE';
      constructor(public event: INotificationSseEvent) {}
    }
  }

